import type { SkeletonProps } from '@fluentui/react-components';
import { Skeleton, SkeletonItem, makeStyles, tokens } from '@fluentui/react-components';

const useStyles = makeStyles({
  invertedWrapper: {
    backgroundColor: tokens.colorNeutralBackground1,
  },
  firstRow: {
    alignItems: 'center',
    display: 'grid',
    paddingBottom: '12px',
    position: 'relative',
    gap: '12px',
    gridTemplateColumns: 'min-content 80%',
  },
  secondThirdRow: {
    alignItems: 'center',
    display: 'grid',
    paddingBottom: '12px',
    position: 'relative',
    gap: '12px',
    gridTemplateColumns: 'min-content 20% 20% 15% 15%',
  },
});

export const LoadingSkeleton = (props: Partial<SkeletonProps>) => {
  const styles = useStyles();
  return (
    <div className={styles.invertedWrapper}>
      <Skeleton {...props} aria-label="Loading Content">
        <div className={styles.firstRow}>
          <SkeletonItem shape="circle" size={32} />
          <SkeletonItem shape="rectangle" size={24} />
        </div>
        <div className={styles.secondThirdRow}>
          <SkeletonItem shape="circle" size={32} />
          <SkeletonItem size={24} />
          <SkeletonItem size={24} />
          <SkeletonItem size={24} />
          <SkeletonItem size={24} />
        </div>
        <div className={styles.secondThirdRow}>
          <SkeletonItem shape="square" size={24} />
          <SkeletonItem size={24} />
          <SkeletonItem size={24} />
          <SkeletonItem size={24} />
          <SkeletonItem size={24} />
        </div>
      </Skeleton>
    </div>
  );
};
